module.exports = __webpack_public_path__ + "static/img/01.ce04d0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/01.jpg
// module id = 396
// module chunks = 1